module.exports = __webpack_public_path__ + "img/27.4e1bdf07.jpg";